import { Link } from "react-router-dom";
import "./carddocument.scss";
import { ICardResponse } from "../../../core/models";

export interface ICardDocumentProps {
  props?: ICardResponse;
}

const CardDocument = ({ props }: ICardDocumentProps) => {
  return (
    <Link
      to={{
        pathname: props?.detailUrl,
      }}
      className="card-document"
    >
      <div className="card-document__image">
        <img
          src={props?.listImage?.src}
          width={164}
          height={100}
          alt={props?.listImage?.alt}
          style={{ height: "auto", width: "100%" }}
        />
      </div>
      <div className="card-document__text">
        <div className="date-container">
          <span className="date">{props?.dateAreaFormatted}</span>
          <span className="time ">{props?.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
        <span className="title">
          <strong>{props?.title}</strong>
        </span>
      </div>
    </Link>
  );
};

export default CardDocument;
